import React from "react";
import Head from "next/head";
import { Template } from "./data";

interface Props {
  type: any;
  data?: any;
}

const Schemas = ({ type, data }: Props) => {
  const schemaData = Template[type](data); // Generate schema
  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(schemaData),
        }}
      ></script>
    </Head>
  );
};

export default Schemas;
